// Always take the lowest status between LS and GS
// IN_PROGRESS -> COMPLETED -> BOOKED -> PAID

/**
 * discontinued: NOT_STARTED = 0
 * IN_PROGRESS = 1 // "Pendent"
 * COMPLETED = 2 // "Geliefert"
 * ARCHIVED = 3 // "Archiviert"
 * PAID_SINGLE = 4 // "Verbucht als Einzelrechnung"
 * PAID_MONTHLY = 5 // "Verbucht als Sammelrechnung"
 * discontinued: REQUESTED = 10 // "Auftragseingang"
 * BOOKED_SINGLE = 21 // "Verbucht als Einzelrechnung"
 * BOOKED_MONTHLY = 22 // "Verbucht als Sammelrechnung"
 */
export enum JobStatusEnum {
	// discontinued: NOT_STARTED = 0,
	IN_PROGRESS = 1,
	COMPLETED = 2,
	ARCHIVED = 3,
	PAID_SINGLE = 4,
	PAID_MONTHLY = 5,
	REQUESTED = 10, // TODO: discontinued ...now job requests are a channel and the job is created after acceptance 
	BOOKED_SINGLE = 21,
	BOOKED_MONTHLY = 22,
}

// Only exists to have a label for the waiting for connection request status
// Not used in the database
export enum VirtualJobStatusEnum {
	WAITING_FOR_CONNECTION_REQUEST = 999,
}

export const jobStatusToLabel = {
	[JobStatusEnum.IN_PROGRESS]: "Pendent",
	[JobStatusEnum.COMPLETED]: "Geliefert",
	[JobStatusEnum.ARCHIVED]: "Archiviert",
	[JobStatusEnum.BOOKED_SINGLE]: "Verbucht als Einzelrechnung",
	[JobStatusEnum.BOOKED_MONTHLY]: "Verbucht in Sammelrechnung",
	[JobStatusEnum.PAID_SINGLE]: "Gezahlt per Einzelrechnung",
	[JobStatusEnum.PAID_MONTHLY]: "Gezahlt per Sammelrechnung",
	[JobStatusEnum.REQUESTED]: "Auftragseingang", // TODO: discontinued ...now job requests are a channel and the job is created after acceptance 
	[VirtualJobStatusEnum.WAITING_FOR_CONNECTION_REQUEST]:
		"Warten auf Verbindungsanfrage",
};
